import { DefaultOptions, MutationCache, QueryClient } from '@tanstack/react-query';

const defaultOptions: DefaultOptions = {
  queries: {
    suspense: false,
    staleTime: 30 * 60 * 1000,
    // refetchOnWindowFocus: false,
    // refetchOnMount: false,
    retry: 0,
    networkMode: 'online',
  },
  mutations: {
    networkMode: 'offlineFirst',
  },
};

const queryClient = new QueryClient({
  defaultOptions,
  // Job activity can be generated by almost any mutation in the app (rooms,
  // photo notes, tasks, assignees...). Rather than wiring invalidation into
  // each one individually, any successful mutation refreshes the activity
  // feed for whichever job is currently open. This also covers in-app tab
  // switches, which never fire a window focus event to trigger a refetch.
  mutationCache: new MutationCache({
    onSuccess: () => {
      queryClient.invalidateQueries(['job-activity']);
    },
  }),
});

export default queryClient;
